import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErr, fetchAuth } from "../../../store/authSlice";
import { getDashboardPath, UNIFIED_FORGOT_PASSWORD_PATH } from "../../../utils/authRedirect";
import { usePortal } from "../../../context/PortalContext";
import { PORTALS } from "../../../utils/portalTypes";
import AuthLoginFlow from "../Auth/AuthLoginFlow";
import { unifiedLoginSubtitle } from "../Auth/portalAuthCopy";
import a from "../Auth/auth.module.css";
import Seo from "../../Seo";

const portal = PORTALS.patient;

export default function PatientLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subdomain, clinic } = usePortal();
  const { err, isAuth, role, load } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuth && role) {
      navigate(getDashboardPath(role), { replace: true });
    }
  }, [isAuth, role, navigate]);

  const submit = ({ login, password }) => {
    dispatch(clearErr());
    dispatch(fetchAuth({ subdomain, login, password }));
  };

  const errorText =
    typeof err === "string" ? err : err?.message || err?.error || null;

  const clubName = clinic?.name || null;

  return (
    <>
      <Seo
        noindex
        title={clubName ? `Вход — ${clubName}` : "Вход в кабинет клуба"}
      />
      <AuthLoginFlow
        heroBadge={clubName}
        portalId="patient"
        backTo={portal.home}
        backLabel="Назад"
        title="Вход"
        subtitle={unifiedLoginSubtitle(clubName)}
        emailPlaceholder="+7 … или email"
        loading={load}
        error={errorText}
        onSubmit={submit}
        footer={
          <div className={a.footerLinksModern}>
            <Link to={UNIFIED_FORGOT_PASSWORD_PATH}>Забыли пароль?</Link>
          </div>
        }
      />
    </>
  );
}
